import React from 'react'
import { IconProps } from '../types'

type LogoProps = IconProps & {
  preferImage?: boolean
  showWordmark?: boolean
}

// Simple NinjaTrader wordmark logo that follows currentColor
// Matches TradovateLogo sizing behavior and API for drop-in usage
export const NinjaTraderLogo: React.FC<LogoProps> = (props) => {
  let computedHeight: number | undefined = typeof props.height === 'number' ? props.height :
    typeof props.height === 'string' ? parseInt(props.height, 10) : undefined

  if (props.className && !computedHeight) {
    const heightMatch = props.className.match(/h-(\d+)/)
    if (heightMatch && heightMatch[1]) {
      const units = parseInt(heightMatch[1], 10)
      computedHeight = units * 4
    }
  }

  // Use provided NinjaTrader asset URL (raster), fall back to wordmark if needed later
  const heightStyle = computedHeight ? { height: `${computedHeight}px` } : undefined
  return (
    // eslint-disable-next-line no-restricted-syntax
    <span className={props.className} onClick={props.onClick} style={{ display: 'inline-flex', alignItems: 'center', ...(props.style || {}) }}>
      <img
        src="/brand/ninjatrader-logo.png"
        alt="NinjaTrader logo"
        // eslint-disable-next-line no-restricted-syntax
        style={{ ...heightStyle, width: 'auto', display: 'block' }}
      />
    </span>
  )
}

export const NinjaTraderLogoNegative = NinjaTraderLogo
